import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateZipcodeInternacionalActions } from "store/ducks/settings/zipcode-internacional";

export function* updateZipcodeInternacionalRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/zipcode-internacional/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateZipcodeInternacionalActions.success(data));
    notify("success", "Zipcode atualizado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateZipcodeInternacionalActions.failure(errorMessage));
  }
}
